import { useSelector } from "react-redux";
import { badgesSelector } from "../../../../../../redux/eventEdition/selectors/eventEdition.selectors";
import { DecryptBadgeResponse, IPersonBadge } from "../../../../../../common/types";
import { CustomerTypes } from "../../../../../createBadge/enums/CustomerTypes";
import { BadgeStatuses, StaffUserAccess } from "../../../../../../common/enums";
import { useState } from "react";
import { QrTypes } from "../../../../../qr/enums";
import FreyaStorage from "../../../../../../common/freyaStorage/FreyaStorage";
import { decodeBadgeQr, decodeShortenedBadge, parseBadgeData } from "../../../../../freya/scanBadge/hooks/utils/utils";
import { StaffScannerProps } from "../../../../../qr/interfaces";

export const useStaffOverrideQrScanner = ({ isFreya, skipUserAccessCheck, allowedRoles }: StaffScannerProps) => {
  const [maskType, setMaskType] = useState(QrTypes.SCANNING);
  const badges = useSelector(badgesSelector) as IPersonBadge[];

  const resetMask = () => {
    setTimeout(() => {
      setMaskType(QrTypes.SCANNING);
    }, 2000);
  };

  const getOdinBadge = (qrCode: string) => {
    const foundBadge = badges.find(
      ({ customerType, status, qrCodeContent }) =>
        customerType === CustomerTypes.STAFF && status === BadgeStatuses.ACTIVE && qrCodeContent?.trim() === qrCode.trim()
    );

    if (!foundBadge) {
      return null;
    }

    if (skipUserAccessCheck) {
      return foundBadge;
    }

    const { supportStaffDetails } = foundBadge;
    const allowed = allowedRoles && allowedRoles.length > 0 ? allowedRoles : [StaffUserAccess.MANAGER, StaffUserAccess.FINANCE];
    const isValidUserAccess = allowed.includes(supportStaffDetails?.userAccess as StaffUserAccess);

    if (isValidUserAccess) {
      return foundBadge;
    }
    return null;
  };

  const getFreyaBadge = async (qrCode: string) => {
    const content = decodeBadgeQr(qrCode);
    if (!content) {
      return null;
    }
    const badgeFromStorage = (await FreyaStorage.getDecryptedBadge(
      content.badgeId,
      content.passphrase,
      content.badgeVersion,
      qrCode
    )) as DecryptBadgeResponse;
    const parsedBadgeData = decodeShortenedBadge(parseBadgeData(badgeFromStorage.decryptedBadge!));

    if (parsedBadgeData && parsedBadgeData.customerType === CustomerTypes.STAFF) {
      if (parsedBadgeData.status === BadgeStatuses.ACTIVE) {
        return parsedBadgeData;
      }
    }
    return null;
  };
  const checkQrCodeForOverride = async (qrCode: string) => {
    if (maskType !== QrTypes.SCANNING) {
      return { success: false };
    }
    let existingBadge;

    if (isFreya) {
      existingBadge = await getFreyaBadge(qrCode);
    } else {
      existingBadge = getOdinBadge(qrCode);
    }

    if (!existingBadge) {
      setMaskType(QrTypes.ERROR);
      resetMask();
      return { success: false };
    }
    setMaskType(QrTypes.SUCCESS);
    resetMask();
    return { success: true, authorizedById: existingBadge.id };
  };

  return {
    checkQrCodeForOverride,
    maskType
  };
};
